module.exports = __webpack_public_path__ + "generic-challenge.9e858bb75bd76a58858d052b910cb497.png";